import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CarsService } from '../cars.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { NbDialogConfig, NbDialogService } from '@nebular/theme';
import { faCartPlus, faGlobe, faLock, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { map, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { round } from 'lodash';
import { MyCarModalComponent } from '../my-list/my-car-modal/my-car-modal.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ThankYouDialogComponent } from '../car-modal/thank-you-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '../../auth/login/reducers/login.reducer';
import { selectLoginState } from '../../auth/login/selectors/login.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { UserInfoModalComponent } from '../user-info/user-info-modal.component';
import { CarModalComponent } from '../car-modal/car-modal.component';
import {CurrencyService} from '../../services/currency.service';
import { TranslateService } from '@ngx-translate/core';

declare let dataLayer: Array<any>;

@Component({
  selector: 'app-car-overview',
  templateUrl: './car-overview.component.html',
  styleUrls: ['./car-overview.component.scss'],
  providers: [MessageService]
})
export class CarOverviewComponent implements OnInit {
  isLoading = true;
  faCartPlus: any = faCartPlus;
  faInvoice = faFileInvoice;

  isLoadingCalc: BehaviorSubject<boolean>;
  isLoadingCalcSubscription: Subscription;
  loaded = false;

  vehicleValue: BehaviorSubject<number>;
  vehicleValueSubscription: Subscription;
  calculatedPrice: number;

  data: any;
  coll: any;
  source: 'commercial' | 'personal';
  importType = 'Commercial';
  currencies: any;
  mode: string;
  countries: any[];
  exwCountries: any[] = [];
  fcaCountries: any[] = [];
  countriesOnDisplay: any[] = [];
  fcaCountriesOnDisplay: any[] = [];
  price: any;
  carForm: FormGroup;
  harbors: any[] = [];
  photos: any[] = [];
  shipmentMethods: any[] = [];
  currencies$: Observable<any[]>;
  doorNumbers: number[] = Array.from({ length: 6 }, (_, i) => i + 1);
  seatNumbers: number[] = Array.from({ length: 11 }, (_, i) => i + 1);
  faGlobe: any = faGlobe;
  exwRates: any[] = [];
  exwSelectedCountry: any = '';
  exwSelectedCity: any = '';
  exwConfig = { countries: [], cities: [], harbors: [] };
  exwCities: any[] = [];
  exwSelectFromGoogleCity: boolean = false;
  fcaSelectFromGoogleCity: boolean = false;
  fcaSelectedCountry: any = '';
  fcaSelectedHarbor: any = '';
  fcaHarbors: any[] = [];

  selectedCurrency: any;
  selectedCfrCurrency: any;

  showDirham = false;

  placesOptions = {
    types: ['(cities)'],
  };
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;

  castUSDToDirham(usd: number): number {
    const conversionRate = 3.67;
    return usd * conversionRate;
  }

  castEURToDirham(eur: number): number {
    const conversionRate = 4.05;
    return eur * conversionRate;
  }

  getCarPrice(car: any) {
    if (this.showDirham) {
      return (this.castUSDToDirham(car.CarPrice) + this.castEURToDirham(2000)) * 1.05 + this.castUSDToDirham(1500);
    }
    return car.C_Price;
  }

  onRateChange($event: any): void {
    console.log($event);
    this.carForm.get('RateType')?.patchValue($event);
    this.carForm.get('ExwCity')?.patchValue(null);
    this.carForm.get('ExwRateId')?.patchValue(null);
    this.carForm.get('Country')?.patchValue(null);
    this.carForm.get('FcaRateId')?.patchValue(null);
    this.carForm.get('FcaDischargeHarbor')?.patchValue(null);
    this.carForm.get('FcaHarbor')?.patchValue(null);
    this.carForm.get('CfrType')?.patchValue(null);
    this.carForm.get('CfrPrice')?.patchValue(null);
    this.carForm.get('CfrCurrencyType')?.patchValue(null);
    this.carForm.get('CfrImportType')?.patchValue(null);
    this.fcaSelectedCountry = '';
    this.exwSelectedCountry = '';
    if ($event === 'FCA') {

      this.fcaCountriesOnDisplay = this.fcaCountries;

    } else if ($event === 'EXW') {
      this.countriesOnDisplay = this.exwCountries;
    }
  }

  onLocationToggleChange(checked: boolean): void {
    if (checked) {
      this.carForm.get('Location').setValue('Israel');
    } else {
      this.carForm.get('Location').setValue('');
    }
  }

  onCertToggleChange(checked: boolean): void {
    if (checked) {
      this.carForm.get('CertificateOfOrigin').setValue('Yes');
    } else {
      this.carForm.get('CertificateOfOrigin').setValue('No');
    }
  }
  loginStatus$: Observable<State>;
  isLogin = false;
  url = 'car-market';

  constructor(private _fb: FormBuilder,
    private store: Store<AppState>,
    private messageService: MessageService,
    private carService: CarsService,
    private router: Router,
    public dialog: MatDialog,
    public dialogService: NbDialogService,
    private breakpointObserver: BreakpointObserver,
    private activatedRoute: ActivatedRoute,
    public currencyService: CurrencyService,
    private translate: TranslateService,
  ) {

    const userId = sessionStorage.getItem('user-id');

    if (userId) {
      // User is logged in, return true
      this.isLoading = true;
    }
    this.loginStatus$ = this.store.select(selectLoginState).pipe(map(loginState => {
      console.log('loginStatus', loginState);

      return loginState;
    }))
    this.loginStatus$.subscribe((state) => {
      console.log('loginStatus sub', state);
      this.isLogin = state.isLogin;
    })
    this.data = carService.carSubject.value;
  }

  openDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      data: {
        images: this.data.Files,
        currentIndex: index
      },
      panelClass: 'bounce-dialog'
    });
  }

  closeDialog(): void {
    this.carService.carResponseSubject.next(null)
    this.router.navigate(['../' + this.url], {
      queryParams: {
        id: null,
        importType: this.carService.carImportType,
        tab: 0
      },
      queryParamsHandling: 'merge'
    });
  }

  toggleInterest() {

    const dConfig = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
    };
    const popup = this.dialog.open(UserInfoModalComponent,
      {
        width: this.isMobileView() ? '400px' : '400px',
        panelClass: 'custom-dialog-padding',
        data: {
          id: this.data.id
        }
      });
    popup.afterClosed().subscribe(res => {
      console.log(res);

      if (!res) {
        return;
      }
      dataLayer.push({
        event: 'button_click_interested',
        item_id: this.data.id,
        item_name: this.data.Manufacturer + ' ' + this.data.Model,
        item_price: this.data.CarPrice,
        item_year: this.data.ManufactureDate,
        user_id: sessionStorage.getItem('user-id'),
        userId: sessionStorage.getItem('user-id'),
      });

      const dialogConfig = {
        hasBackdrop: true,
        closeOnEsc: true,
        backdropClass: '',
        closeOnBackdropClick: false,
        hasScroll: false,
        autoFocus: false,
        viewContainerRef: undefined,
      };
      this.carService.updateInterest(this.data.id, 'Interested', this.importType).subscribe((res: any) => {
        console.log(res);
      });
      const thankYouDlg = this.dialogService.open(ThankYouDialogComponent, dialogConfig);

      thankYouDlg.onClose.subscribe((result: any) => {
        this.carService.carResponseSubject.next(this.data)
        this.router.navigate(['../' + this.url], {
          queryParams: {
            id: null,
            importType: this.carService.carImportType,
            tab: 0
          },
          queryParamsHandling: 'merge'
        });

      });
    })

  }

  private init() {
    this.exwRates = this.exwCountries;
    this.carForm = this.createCarForm();
    this.exwSelectedCountry = this.data?.Rate?.country ?? '';
    this.fcaSelectedCountry = this.data?.Rate?.country ?? '';
    this.countriesOnDisplay = this.exwCountries;
    this.fcaCountriesOnDisplay = this.fcaCountries;
    this.selectedCurrency = this.data?.CurrencyType ?? '';
    this.selectedCfrCurrency = this.data?.Rate?.cfrCurrencyType ?? '';
    this.isLoading = false;
    this.loaded = true;

  }

  async ngOnInit(): Promise<any> {
    this.currencyService.ensureLoaded();
    this.showDirham = sessionStorage.getItem('user-id') === '530';

    this.activatedRoute.queryParams.pipe(
      switchMap(async (params) => {
        this.url = params['url'] || 'car-market';
        const id = params['id'] || '';
        console.log(`params=${this.url}, id=${id}`);
        if( id ) {
          try {
            this.data = await this.carService.getCarByIdNew(+id).toPromise();
            this.init();
          } catch (error) {
            console.log(error);

            this.init();
          }
        } else {
          this.init();
        }
      })).subscribe(() => {
      })

  }

  ngOnDestroy() {
  }

  createCarForm() {
    const id = this.data ? this.data.id || '' : '';
    const filesArray = this.data && this.data.Files ? this._fb.array(this.data.Files) : this._fb.array([]);
    const mainFile = this.data && this.data.Files && this.data.Files.length > 0
      ? this.data.Files.find((file: any) => file.isMain)?.title || ''
      : '';


    return this._fb.group({
      id: [id],
      Manufacturer: [this.data?.Manufacturer ?? '', Validators.required],
      Model: [this.data?.Model ?? '', Validators.required],
      FinishLevel: [this.data?.FinishLevel ?? ''],
      TotalWeight: [this.data?.TotalWeight ?? ''],
      ManufactureDate: [this.formatDate(this.data?.ManufactureDate ?? '')],
      CarStatus: [this.data?.CarStatus ?? ''],
      FirstUseDate: [this.formatDate(this.data?.FirstUseDate ?? '')],
      Mileage: [this.data?.Mileage ?? ''],
      SaleCondition: [this.data?.SaleCondition ?? ''],
      Port: [this.data?.Port ?? ''],
      OverlandDeliveryPrice: [this.data?.OverlandDeliveryPrice ?? ''],
      PickupLocation: [this.data?.PickupLocation ?? ''],
      CertificateOfOrigin: [this.data?.CertificateOfOrigin ?? 'No'],
      Location: [this.data?.Location ?? ''],
      ExteriorColor: [this.data?.ExteriorColor ?? ''],
      UpholsteryColor: [this.data?.UpholsteryColor ?? ''],
      FuelType: [this.data?.FuelType ?? ''],
      NumberOfDoors: [this.data?.NumberOfDoors ? parseInt(this.data.NumberOfDoors, 0) : null],
      NumberOfSeats: [this.data?.NumberOfSeats ? parseInt(this.data.NumberOfSeats, 0) : null],
      CarPrice: [this.data?.CarPrice ?? '', Validators.required],
      CurrencyType: [this.data?.CurrencyType ?? '', Validators.required],
      Notes: [this.data?.Notes ?? ''],
      MainFile: [mainFile],
      Status: [this.data?.Status ?? ''],
      Files: filesArray,
      PollutionRank: [this.data?.PollutionRank ?? '4'],
      EquipLevel: [this.data?.EquipLevel ?? '4'],
      RateId: [this.data?.id ?? ''],
      RateType: [this.data?.Rate?.type ?? ''],
      Country: [this.data?.Rate?.country ?? ''],
      ExwCity: [this.data?.Rate?.exwCity ?? ''],
      ExwRateId: [this.data?.Rate?.exwRateId ?? ''],
      FcaRateId: [this.data?.Rate?.fcaRateId ?? ''],
      FcaHarbor: [this.data?.Rate?.fcaHarbor ?? ''],
      FcaDischargeHarbor: [this.data?.Rate?.fcaDischargeHarbor ?? ''],
      CfrImportType: [this.data?.Rate?.cfrImportType ?? ''],
      CfrPrice: [this.data?.Rate?.cfrPrice ?? ''],
      CfrCurrencyType: [this.data?.Rate?.cfrCurrencyType ?? ''],
    });

  }

  get f() {
    return this.carForm.controls;
  }

  saveCar(status: string) {
  }

  cancelCar(src: string = '') {
    dataLayer.push({
      event: 'button_click_Close_' + src,
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    this.carService.carResponseSubject.next(this.data)
    // this.nbDialogRef.close(this.data);
    this.router.navigate(['../' + this.url], {
      queryParams: {
        id: null,
        importType: this.carService.carImportType,
        tab: 0
      },
      queryParamsHandling: 'merge'
    });

  }

  createInvoice(in0: any) {
    dataLayer.push({
      event: 'button_click_create_invoice',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });


    this.toggleMoreInfo(this.data);
  }

  isMobileView(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  toggleMoreInfo(car: any) {

    const isMobile = this.isMobileView();

    dataLayer.push({
      event: 'button_click_more_info_list',
      item_id: car.id,
      item_name: car.Manufacturer + ' ' + car.Model,
      item_price: car.CarPrice,
      item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    const dialogConfig: NbDialogConfig<any> = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      dialogClass: isMobile ? 'full-screen-dialog' : '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
      context: {
        data: car ?? {},
        source: this.source,
        isLoadingCalc: this.isLoading,
        vehicleValue: this.vehicleValue
      }
    };

    console.log(this.source);

    const dialogRef = this.dialogService.open(CarModalComponent, dialogConfig);

    if (isMobile) {
      dialogRef.componentRef.instance.nbDialogRef = dialogRef;
    }

    dialogRef.onClose.subscribe((result: any) => {
      console.log('Dialog closed', result);
      if (result?.code === 200) {
      }
    });

  }

  addToBasket(data: any): void {
    dataLayer.push({
      event: 'button_click_basket',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    this.carService.addToMyList(data.id).pipe(map((res: any) => {
      if (res.code === 200) {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('CAR_MARKET.ADD_VEHICLE_TITLE'), detail: this.translate.instant('CAR_MARKET.ADD_VEHICLE_SUCCESS') });
      } else {
        this.messageService.add({ severity: 'danger', summary: this.translate.instant('CAR_MARKET.ADD_VEHICLE_TITLE'), detail: this.translate.instant('CAR_MARKET.ADD_VEHICLE_ERROR') });
      }
    })).subscribe();

  }

  formatDate(date: string): string {
    if (!date) {
      return '';
    }
    return moment.utc(date).format('DD-MM-YYYY');
  }
  getFormattedDate(date: string): string {
    if (date === '') {
      return '';
    }
    const isoDate = new Date(date).toISOString();
    return isoDate.split('T')[0];
  }

  /** Reading direction for the detail view, driven by the active UI language. */
  get dir(): string {
    return this.translate.currentLang === 'he' ? 'rtl' : 'ltr';
  }

  getWeightText(): string {
    let weight = this.carForm.get('TotalWeight').value;
    switch (weight) {
      case 1:
        return this.translate.instant('CAR_MARKET.WEIGHT_UP_TO_3500');
      case 2:
        return this.translate.instant('CAR_MARKET.WEIGHT_3500_TO_4500');
      case 3:
        return this.translate.instant('CAR_MARKET.WEIGHT_ABOVE_4500');
      default:
        return '';
    }
  }

  getPrice(): string {
    if (this.data && this.loaded) {
      let ils: number | null = null;
      if (this.importType === 'Commercial') {
        if (this.url === 'car-market') {
          ils = this.round(this.data.C_Price_Personal, 0);
        } else if (this.coll || this.data.ManufactureYear < 2000) {
          ils = this.round(this.data.C_Price_Collector, 0);
        } else if (this.data.ManufactureYear >= 2022) {
          ils = this.round(this.data.C_Price, 0);
        }
      } else if (this.importType === 'Taxi' && !this.coll) {
        ils = this.round(this.data.C_PriceComTaxi, 0);
      }
      if (ils == null) { return ''; }
      const code = this.currencyService.code;
      const locale = code === 'ILS' ? 'he-IL' : 'en-US';
      return Math.round(this.currencyService.convertFromIls(ils))
        .toLocaleString(locale, { style: 'currency', currency: code, maximumFractionDigits: 0 });
    }
    return '';
  }

  protected readonly faLock = faLock;
  protected readonly round = round;
}
